import React from "react";
import "./GSTRSteps.scss";
import { Link } from "react-router-dom";
import { CommonHeader } from "../../../components/commons";
import { GSTRStep1, GSTRStep2, GSTRStep3 } from "../../../assets/images";

type AppProps = {
  history: any;
};

const GSTRSteps = ({ history }: AppProps) => {
  const handleGoBack = () => {
    history.goBack();
  };
  return (
    <>
      <div
        className="gstr-step-container"
        style={{ margin: 0, maxWidth: "100%" }}
      >
        <h1>Steps for GSTR API Access</h1>

        <div>
          <h2 className="gstr-step-title mt-4">
            Step 1: Login to Your GST Account
          </h2>
          <p className="gstr-step-description">
            Navigate to the{" "}
            <a
              href="https://www.gst.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="gstr-link"
            >
              GST website
            </a>{" "}
            and log in with your <span className="highlight">Username</span> and
            <span className="highlight"> Password</span>. Once logged in, click
            on
            <strong> My Profile</strong> from the GST Option drop-down menu.
          </p>
          <img
            src={GSTRStep1}
            alt="GST login page (Image 1.0)"
            className="step-image"
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <h2 className="gstr-step-title mt-4">Step 2: Manage API Access</h2>
          <p className="gstr-step-description">
            Select <strong>Manage API Access</strong> from the left-side menu to
            access the API settings page on the GSTN portal.
          </p>
          <img
            src={GSTRStep2}
            alt="Manage API Access (Image 1.1)"
            className="step-image"
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <h2 className="gstr-step-title mt-4">
            Step 3: Enable GST API Access
          </h2>

          <p className="gstr-step-description">
            Enable GST API access by setting the{" "}
            <span className="highlight">Enable API Request</span> option to{" "}
            <span className="highlight">Yes</span>. Then, select the session
            time from the drop-down menu. This time determines how long the OTP
            authentication will be valid. For example, if you choose 6 hours,
            the OTP will expire after 6 hours, and you’ll need to generate a new
            one. We recommend choosing <span className="highlight">7 days</span>{" "}
            or <span className="highlight">30 days</span> to ensure enough time
            to complete the GST return filing. Once you've selected the
            duration, click <strong>Confirm</strong> to save your settings.
          </p>

          <img
            src={GSTRStep3}
            alt="Enable API Access (Image 1.2)"
            className="step-image"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </>
  );
};

export default GSTRSteps;
